import { Component, OnDestroy } from '@angular/core';
import { DwDecoratorType, DwGridColumn, DwGridColumnBaseComponent } from '@devwareapps/devware-cap';
import { Subscription } from 'rxjs';

import { VideoEntity } from '../../../../meta-data/app-meta-data.service';
import { VideoThumbnailPreviewService } from '../../services/video-thumbnail-preview.service';

@DwGridColumn({
  keyName: 'video-thumbnail-column',
  display: 'Video Thumbnail Column',
  decoratorType: DwDecoratorType.component,
  isGlobal: true,
  allowAction: false,
  showActionButtonConfig: false,
  requireAction: false,
  useAutoRowHeight: true,
  allowAttr: true,
  requireAttr: true
})
@Component({
  selector: 'app-video-thumbnail-grid-column',
  templateUrl: './video-thumbnail-grid-column.component.html',
  styleUrls: ['./video-thumbnail-grid-column.component.scss']
})
export class VideoThumbnailGridColumnComponent extends DwGridColumnBaseComponent implements OnDestroy {
  private static readonly placeholderThumbnailUrl = 'assets/img/no-image-available.png';

  thumbnailAlt = 'Video thumbnail';
  thumbnailFailed = false;
  thumbnailLoading = false;
  thumbnailUrl = VideoThumbnailGridColumnComponent.placeholderThumbnailUrl;

  private thumbnailSubscription?: Subscription;

  constructor(private readonly videoThumbnailPreviewService: VideoThumbnailPreviewService) {
    super();
  }

  setupColumn(): void {
    this.thumbnailSubscription?.unsubscribe();
    this.thumbnailFailed = false;
    this.thumbnailLoading = false;
    this.thumbnailUrl = VideoThumbnailGridColumnComponent.placeholderThumbnailUrl;

    const video = this.params?.data as VideoEntity;
    this.thumbnailAlt = video?.VideoName ? `${video.VideoName} thumbnail` : 'Video thumbnail';
    if (!video?.ThumbnailUrl) {
      return;
    }

    this.thumbnailLoading = true;
    this.thumbnailSubscription = this.videoThumbnailPreviewService.getThumbnail(video)
      .subscribe(thumbnailUrl => {
        this.thumbnailUrl = thumbnailUrl || VideoThumbnailGridColumnComponent.placeholderThumbnailUrl;
        this.thumbnailLoading = false;
      });
  }

  handleThumbnailError(): void {
    if (this.thumbnailUrl !== VideoThumbnailGridColumnComponent.placeholderThumbnailUrl) {
      this.thumbnailUrl = VideoThumbnailGridColumnComponent.placeholderThumbnailUrl;
      return;
    }

    this.thumbnailFailed = true;
  }

  ngOnDestroy(): void {
    this.thumbnailSubscription?.unsubscribe();
  }
}
